// src/CiqlerDetail.js
import React from 'react';
import './reportingTool.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';



function ReportingToolDetail() {
  return (
<div>
  {/* Navigation Bar */}
  <nav className="navbar">
    <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
      <h1>Ziad Aly</h1>
    </Link>
  </nav>

  {/* Main Background */}
  <div className="mainbackground">
    <div className="reportingtool-project-detail notion-style">
      {/* Video at the Top */}
      <div className="reportingtool-video-container">
        <video
          controls
          width="100%"
          src={`${process.env.PUBLIC_URL}/homzmart_|_data_tool (720p).mp4`}
        />
      </div>

      {/* Text Content */}
      <div className="detail-content">
        <div className="text-container">
          <h1>Reporting Tool</h1>
                 {/* Bottom-Right Image */}
        <div className="projectImager">
          <img
            src={`${process.env.PUBLIC_URL}/homzmart.png`}
            alt="Reporting Tool project"
          />
        </div>
          <h2>Problem Statement</h2>
          <p>
            The e-commerce startup faced delays in decision-making due to fragmented data sources, 
            inefficient handling of large CSV files, and limited real-time insights or visualization capabilities.
          </p>
          <h2>Value Proposition</h2>
          <p>Developed and deployed an end-to-end data solution that:</p>
          <ul>
            <li>
              <strong>Unified Data Integration:</strong> Streamlined data from multiple sources into a centralized 
              Data Lake using AWS Glue and Python Spark.
            </li>
            <li>
              <strong>Real-Time Analytics:</strong> Enabled instant querying of historical and live data via AWS Athena and SQL.
            </li>
            <li>
              <strong>Improved Efficiency:</strong> Automated large CSV exports with a REST API and WebSockets built in Nodejs.
            </li>
            <li>
              <strong>Live Reporting:</strong> Provided intuitive dashboards through AWS QuickSight for real-time KPIs.
            </li>
            <li>
              <strong>Accelerated Decisions:</strong> Transformed the company’s data operations, enabling faster, data-driven decision-making.
            </li>
          </ul>
          <h2>Technology</h2>
          <ul>
            <li>
              SQL
            </li>
            <li>
              MongoDB
            </li>
            <li>
            <strong> Python:</strong> Spark, Pandas
            </li>
            <li>
            <strong>Nodejs:</strong> Streamjs, Pusher
            </li>
            <li>
              Reactjs
            </li>
            <li>
              Nginx
            </li>
            <li>
            <strong>AWS:</strong> EC2, Lambda Function, Glue, , RDS, Athena,, S3, QuickSight, Cognito, Route 53
            </li>
            <li>
              GitHub
            </li>
            <li>
              Jira
            </li>
          </ul>
          <h2>Team</h2>
          <a href="https://www.linkedin.com/company/homzmart/posts/?feedView=all"   style={{ marginLeft: "25px", color: "inherit" }} rel="noopener noreferrer">Homzmart</a>
          </div>
          <h2>Status</h2>
          <p style={{ display: "flex", alignItems: "center" }}>
  <span
    style={{
      width: "8px",
      height: "8px",
      backgroundColor: "green",
      borderRadius: "50%",
      display: "inline-block",
      marginRight: "8px",
    }}
  ></span>
  Online for more than 2 years serving more than 500 users across two countries.
</p>

      </div>
    </div>
  </div>
</div>
  );
}

export default ReportingToolDetail;